import './scss/main.scss';
import Swiper, { Pagination, Autoplay, EffectCoverflow } from 'swiper';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import initSportData from './modules/sport-data'
import Cookies from 'js-cookie'
'use strict';

/* Global Variables and Functions */
const ajaxUrl = '/wp-admin/admin-ajax.php';

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/* JS Start when Document Load & DOM build*/
document.addEventListener('DOMContentLoaded', ready);
function ready() {

    /* Header Fixed */
    const scrollUpButton = document.querySelector('.js-scroll-up');
    const siteHeader = document.querySelector('.site-header');
    let headingSection = document.querySelector('.promo');
    let siteHeaderHeight = 0;
    let headingSectionHeight = 0;

    if (!headingSection) {
        headingSection = siteHeader;
    }

    if (headingSection && siteHeader) {
        headingSectionHeight = headingSection.offsetHeight;

        const headerPosition = () => {
            if (window.scrollY >= headingSectionHeight) {
                siteHeader.classList.add('fixed');
                document.body.classList.add('header-fixed');

                if (scrollUpButton) {
                    scrollUpButton.classList.add('show');
                }
            } else {
                siteHeader.classList.remove('fixed');
                document.body.classList.remove('header-fixed');

                if (scrollUpButton) {
                    scrollUpButton.classList.remove('show');
                }
            }
        }

        headerPosition();

        document.addEventListener('scroll', function () {
            headerPosition();
        });


        const siteNewsletter = document.querySelector('.js-newsletter-modal');

        if (siteNewsletter) {
            let lastScrollTop = 0;

            document.addEventListener('scroll', function(){ // or window.addEventListener("scroll"....
                const st = window.scrollY || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
                if (st > lastScrollTop) {
                    // downscroll code
                    siteNewsletter.classList.remove('show')
                } else if (st < lastScrollTop) {
                    // upscroll code
                    siteNewsletter.classList.add('show')
                } // else was horizontal scroll
                lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            }, false);
        }

    }

    if (siteHeader) {
        // Set --lx-header-height var
        siteHeaderHeight = siteHeader.clientHeight;
        document.documentElement.style.setProperty("--lx-header-height", `${siteHeaderHeight}px`);

        window.addEventListener("resize", () => {
            siteHeaderHeight = siteHeader.clientHeight;
            document.documentElement.style.setProperty("--lx-header-height", `${siteHeaderHeight}px`);
        });

        // Set submenu wrapper
        const headerParentLinks = document.querySelectorAll("#header-menu > .menu-item-has-children > a");

        headerParentLinks.forEach((parentLink) => {
            // Submenu
            const subMenu = parentLink.nextElementSibling;

            if (!subMenu) return;

            // Menu Title
            const menuColTitle = document.createElement("h5");
            menuColTitle.classList.add('menu-col-title');
            menuColTitle.textContent = parentLink.textContent;
            const href = parentLink.getAttribute('href');

            if (href && href !== '#') {
                const menuColTitleLink = document.createElement("a");

                menuColTitleLink.textContent = menuColTitle.textContent;
                menuColTitleLink.setAttribute('href', href);
                menuColTitle.textContent = '';
                menuColTitle.appendChild(menuColTitleLink)
            }

            // Wrapper el
            const subMenuWrapper = document.createElement("div");
            subMenuWrapper.classList.add('sub-menu-wrapper')

            // Inner el
            const subMenuInner = document.createElement("div");
            subMenuInner.classList.add('sub-menu-inner')
            subMenuInner.classList.add('container')

            subMenuWrapper.appendChild(subMenuInner)
            subMenuInner.appendChild(menuColTitle)
            subMenuInner.appendChild(subMenu)
            parentLink.parentElement.appendChild(subMenuWrapper)

            parentLink.addEventListener('click', (e) => {
                e.preventDefault()
            })

            const parentItem = parentLink.parentElement;

            if (!parentItem) return;

            if (window.matchMedia("(max-width: 1024px)").matches) {
                // Tablets and mobile
                parentItem.addEventListener('click', (e) => {
                    e.stopPropagation()

                    const openSubMenu = document.querySelector('.sub-menu-wrapper.active')

                    if (openSubMenu) {
                        openSubMenu.classList.remove('active')
                    }

                    subMenuWrapper.classList.add('active')
                })

                document.addEventListener('click', () => {
                    subMenuWrapper.classList.remove('active')
                })
            } else {
                // Desktop
                parentItem.addEventListener('mouseenter', () => {
                    subMenuWrapper.classList.add('active')
                })

                parentItem.addEventListener('mouseleave', () => {
                    subMenuWrapper.classList.remove('active')
                })
            }



            // Descriptions and Cols
            // const descriptions = parentLink.querySelectorAll('.menu-item-description');

            // descriptions.forEach((descriptionEl) => {
            //     const menuColTitle = document.createElement("h5");
            //     menuColTitle.classList.add('menu-col-title');
            //     menuColTitle.textContent = parentLink.textContent;
            //
            //     descriptionEl.parentElement.parentElement.insertAdjacentElement('beforebegin', menuColTitle )
            //
            //     const menuCol = document.createElement("div");
            //     menuCol.classList.add('menu-col');
            //     subMenu.appendChild(menuCol)
            // })
        })
    }

    /* Set 100vh height */
    // Get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // Listen to the resize event
    window.addEventListener("resize", () => {
        // Execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    // init Swiper
    const swiperRelated = new Swiper('#related-posts', {
        modules: [Pagination, Autoplay, EffectCoverflow],
        // slidesPerView: "auto",
        // effect: 'cards',
        // slidesPerView: 1,
        centeredSlides: true,
        initialSlide: 2,
        spaceBetween: 0,
        allowTouchMove: true,
        effect: 'coverflow',
        slidesPerView: 'auto',
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows : true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        // loop: true,
        // loopedSlides: 1,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: true,
        //     pauseOnMouseEnter: true,
        // },
        // breakpoints: {
        //     576: {
        //         slidesPerView: 2,
        //     },
        //     768: {
        //         slidesPerView: 3,
        //     },
        //     1199: {
        //         slidesPerView: 4,
        //     },
        // }
    });

    // init Sport API
    initSportData();
}

/* ==========================================================================
* jQuery Scripts
* ========================================================================== */
(function($){
    $(document).ready(function() {

        /* Burger Menu Action */
        $('.js-burger').on('click', function () {
            if ($('.header__menu-wrapper').hasClass('active')) {
                $('.header__menu-wrapper').addClass('out');

                setTimeout(function () {
                    $('.header__menu-wrapper').hide();
                    $('.header__menu-wrapper').removeClass('out');
                    $('.js-burger').removeClass('active');
                    $('.header__menu-wrapper').removeClass('active');
                    $('body').removeClass('menu-open');
                }, 200)

                setTimeout(function () {
                    $('.header__menu-wrapper').show();
                }, 500)
            } else {
                $(this).addClass('active');
                $('.header__menu-wrapper').addClass('active');
                $('body').addClass('menu-open');
            }

        });

        $('.page-overlay').on('click', function () {
            $('.js-burger').trigger('click');
        });

        /* Scroll Up */
        $('.js-scroll-up').on('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        /* Scroll To Section */
        $('.js-anchor').on('click', function (e) {
            e.preventDefault();
            const anchorSection = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(anchorSection).offset().top - 80}, 500, 'linear');
        });

        /* Read More Post */
        $('.js-read-more').appendTo($('.article__content-inner p:nth-last-of-type(2)'));
        $('.js-read-more').removeClass('hide');

        const getPosts = function (catId, tagId, page) {
            const skeleton = $('.js-skeleton');
            const loadMore = $('.js-load-more');

            const postsList = $('.js-posts-list');

            const data = {
                action: 'get_posts_by_tag',
                cat_id: catId,
                tag_id: tagId,
                page,
            };

            $(skeleton).removeClass('hide');
            $(loadMore).addClass('hide');

            if (page === 1) {
                $(postsList).html('')
            }

            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data,
                success: function(response) {
                    const res = JSON.parse(response)
                    if (res.success) {
                        $(postsList).append(res.data)
                    }

                    if (res.max_num_pages > page) {
                        // $(loadMore).attr('disabled', false);
                        $(loadMore).removeClass('hide');
                    }
                },
                error: function (request, status, error) {
                    console.log(request, status, error);
                },
                complete: function () {
                    $(skeleton).addClass('hide');
                }
            });
        }

        let page = 1;

        /* Post Tags Navigation */
        $('.js-tag-button').on('click', function () {
            $('.js-tag-button.active').removeClass('active');
            $(this).addClass('active');

            const catId = $(this).data('cat_id');
            const tagId = $(this).data('tag_id');

            // Reset Page
            page = 1

            getPosts(catId, tagId, page);
        });

        /* Post Load More */
        $('.js-load-more-button').on('click', function () {
            const activeTag = $('.js-tag-button.active');

            const catId = $(activeTag).data('cat_id');
            const tagId = $(activeTag).data('tag_id');

            // Increase Page
            page++

            getPosts(catId, tagId, page);
        });

        /* Open Search Modal */
        $('.js-search').on('click', function(e) {
            e.preventDefault();

            $(this).addClass('hide');
            $('.js-header-search').addClass('active');
        });

        /* Open Newsletter Modal */
        if (Cookies.get('disabled_ninedart_newsletter')) {
            $('.js-newsletter-modal').remove();
        }

        $('.js-close-newsletter-modal').on('click', function(e) {
            if (!Cookies.get('disabled_ninedart_newsletter')) {
                Cookies.set('disabled_ninedart_newsletter', '1', { expires: 7, path: '' })
            }

            $('.js-newsletter-modal').removeClass('show');
            const timeout = setTimeout(() => {
                $('.js-newsletter-modal').remove();

                clearTimeout(timeout)
            }, 500)
        });

        $('#forminator-module-228').on('forminator:form:submit:success', function (e, formData) {
            Cookies.set('disabled_ninedart_newsletter', '1', { expires: 365, path: '' })

            const timeout1 = setTimeout(() => {
                $('.js-newsletter-modal').removeClass('show');

                const timeout2 = setTimeout(() => {
                    $('.js-newsletter-modal').remove();

                    clearTimeout(timeout2)
                }, 500)

                clearTimeout(timeout1)
            }, 1000)

        });

        /* Play Video */
        $('.js-play').click(function (e) {
            const post = $(this).closest($('.post-image')).length ? $(this).closest($('.post-image')) : $(this).closest($('.article__image--video'));

            $(post).addClass('active');
            const iframeYouTube = $(post).find('iframe[src*="youtube"]');

            if ($(iframeYouTube).length) {
                const src = $(iframeYouTube).attr('src').replace('autoplay=0', 'autoplay=1');
                $(iframeYouTube).attr('src', src);
            }
        });

        /* Woocommerce Single Product */
        $('body.single-product .variations').appendTo('body.single-product .woocommerce-variation-add-to-cart');

        $('body.single-product .variations select#colour').each(function () {
            $(this).on('change', function () {
                const value = $(this).val();
                console.log(!!value)
                if (value) {
                    $('div.product.type-product').addClass('variation-selected');
                } else {
                    $('div.product.type-product').removeClass('variation-selected');
                }
            })
        });

        /* Woocommerce Checkout */
        $('body').on('init_checkout', function () {

            const interval = setInterval(function () {
                if ($('.wc-block-components-checkout-return-to-cart-button').length) {
                    clearInterval(interval);

                    $('.wc-block-components-checkout-return-to-cart-button').css('pointer-events', 'all');

                    $('.wc-block-components-checkout-return-to-cart-button').on('click', function (e) {
                        e.preventDefault();
                        window.scrollTo(0, 0)

                        $('#contact-fields #email, #shipping input[required], #billing input[required]').each(function () {
                            $(this).trigger( "focus" );
                            $(this).trigger( "blur" );

                            const timeout = setTimeout(function () {
                                if ($('#contact-fields .has-error').length || $('#shipping .has-error').length || $('#billing .has-error').length) {
                                    return;
                                } else {
                                    $('body').addClass('payment-step');
                                }

                                clearTimeout(timeout);
                            }, 500)
                        });
                    })
                }
            }, 500)
        })


    });
})(jQuery, window);